import { render, staticRenderFns } from "./patient-and-family-centred-care.vue?vue&type=template&id=5ba8037e&"
import script from "./patient-and-family-centred-care.vue?vue&type=script&lang=js&"
export * from "./patient-and-family-centred-care.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports